import { render, staticRenderFns } from "./RdpNotice.vue?vue&type=template&id=2efa5c6b&scoped=true&"
import script from "./RdpNotice.vue?vue&type=script&lang=js&"
export * from "./RdpNotice.vue?vue&type=script&lang=js&"
import style0 from "./RdpNotice.vue?vue&type=style&index=0&id=2efa5c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa5c6b",
  null
  
)

export default component.exports